import { createFileRoute, redirect } from "@tanstack/react-router";
import { ApiError, fetchMe, qk } from "@/lib/api";

/** "/" sends you to your default workspace (or sign-in). */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    let me;
    try {
      me = await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: fetchMe });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) throw redirect({ to: "/login" });
      throw e;
    }
    const ws = me.workspaces.find((w) => w.id === me.user?.default_workspace_id) ?? me.workspaces[0];
    if (!ws) throw redirect({ to: "/login" });
    throw redirect({ to: "/$workspace", params: { workspace: ws.slug }, replace: true });
  },
});
